import { SIZE_50 } from '@/lib/gridElements/size';

//kpis
import { fansConfig } from '@/lib/analytics/kpis/facebook/fans';
import { fanGrowthConfig } from '@/lib/analytics/kpis/facebook/fanGrowth';
import { gainedFansConfig } from '@/lib/analytics/kpis/facebook/gainedFans';
import { lostFansConfig } from '@/lib/analytics/kpis/facebook/lostFans';
import { followersConfig } from '@/lib/analytics/kpis/facebook/followers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/facebook/followersEvolution';
import { gainedFollowersConfig } from '@/lib/analytics/kpis/facebook/gainedFollowers';
import { lostFollowersConfig } from '@/lib/analytics/kpis/facebook/lostFollowers';

//charts
import { fansHistoryConfig } from '@/lib/analytics/charts/facebook/fansHistory';
import { ageGenderConfig } from '@/lib/analytics/charts/facebook/ageGenderConfig';
import { gainedLostFansConfig } from '@/lib/analytics/charts/facebook/gainedLostFans';
import { languagesDistributionConfig } from '@/lib/analytics/charts/facebook/languagesDistributionConfig';
import { countriesDistributionConfig } from '@/lib/analytics/charts/facebook/countriesDistributionConfig';
import { citiesDistributionConfig } from '@/lib/analytics/charts/facebook/citiesDistributionConfig';
import { gainedFansPerSourceConfig } from '@/lib/analytics/charts/facebook/gainedFansPerSource';
import { lostFansPerSourceConfig } from '@/lib/analytics/charts/facebook/lostFansPerSource';
import { followersHistoryConfig } from '@/lib/analytics/charts/facebook/followersHistory';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/facebook/gainedLostFollowers';

export const CommunityFacebook = [
    // Line 1
    followersConfig,
    followersEvolutionConfig,
    gainedFollowersConfig,
    lostFollowersConfig,

    // Line 2
    fansConfig,
    fanGrowthConfig,
    gainedFansConfig,
    lostFansConfig,

    // Line 3
    followersHistoryConfig,
    gainedLostFollowersConfig,

    // Line 4
    fansHistoryConfig,
    gainedLostFansConfig,

    // Line 5
    gainedFansPerSourceConfig,
    lostFansPerSourceConfig,

    // Line 6
    ageGenderConfig,
    languagesDistributionConfig,

    // Line 7
    { ...countriesDistributionConfig, size: SIZE_50 },
    { ...citiesDistributionConfig, size: SIZE_50 }
];

export const requestFacebookParams = [
    // FacebookPageMetrics
    [
        'followers',
        'gained_followers',
        'lost_followers',
        'followers_history',
        'followers_evolution',
        'fans',
        'gained_fans',
        'lost_fans',
        'fan_growth',
        'fans_history',
        'gained_lost_fans_history',
        'gained_lost_followers_history',
        'gained_fans_per_source',
        'lost_fans_per_source'
    ],
    // FacebookCommunity
    [
        'ages_genders_distribution',
        'languages_distribution',
        'countries_distribution',
        'cities_distribution'
    ]
];

export const requestFacebookOtherParameters = {
    ages_genders_distribution: {
        type: ageGenderConfig.defaultFilter
    },
    languages_distribution: {
        type: languagesDistributionConfig.defaultFilter
    },
    countries_distribution: {
        type: countriesDistributionConfig.defaultFilter
    },
    cities_distribution: {
        type: citiesDistributionConfig.defaultFilter
    }
};
